<script setup>
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { passwordChecks, passwordStrength, strengthLabel } from '@/utils/auth/password';

const { t } = useI18n();

/** The meter and the list of requirements under a new password. */
const props = defineProps({
  password: { type: String, default: '' },
  confirmation: { type: String, default: '' },
});

const score = computed(() => passwordStrength(props.password));
const checks = computed(() => passwordChecks(props.password, props.confirmation));
const tone = computed(() => ['bg-red-400', 'bg-orange-400', 'bg-amber-400', 'bg-emerald-500', 'bg-emerald-600'][score.value]);
</script>

<template>
  <div class="rounded-2xl bg-deen-ink/[0.03] border border-deen-ink/5 p-4">
    <div class="flex items-center justify-between gap-3 mb-2">
      <span class="text-[11px] font-bold uppercase tracking-widest text-deen-ink/40">{{ t('study.password.meter') }}</span>
      <span class="text-xs font-semibold text-deen-ink/70" aria-live="polite">{{ password ? strengthLabel(score) : '—' }}</span>
    </div>
    <div class="grid grid-cols-4 gap-1.5 mb-3" aria-hidden="true">
      <span v-for="i in 4" :key="i" :class="['h-1.5 rounded-full transition-colors duration-300', password && i <= Math.max(1, score) ? tone : 'bg-deen-ink/10']" />
    </div>
    <ul class="grid grid-cols-2 gap-x-3 gap-y-1.5">
      <li v-for="check in checks" :key="check.id" :class="['flex items-center gap-1.5 text-xs transition-colors', check.ok ? 'text-emerald-700' : 'text-deen-ink/45']">
        <iconify-icon :icon="check.ok ? 'solar:check-circle-bold' : 'solar:record-linear'" class="text-sm shrink-0" aria-hidden="true" />
        <span>{{ check.label }}<span class="sr-only">{{ check.ok ? ' — ispunjeno' : ' — nije ispunjeno' }}</span></span>
      </li>
    </ul>
  </div>
</template>
